import { useNavigate } from "react-router-dom-v5-compat";
import { getNavOrgAthleteWithTeam } from "../../pages/Auth/Org/Athlete/AthletePaths";
import { AthleteFragment, AthleteSearchDocument, AthleteSearchQuery, AthleteSearchQueryVariables } from "../../types";
import { AutocompleteQuerySearchBar } from "../universal/AutocompleteQuerySearchBar/AutocompleteQuerySearchBar";
import { TWTooltip } from "apps/web/src/componentLibrary/TWTooltip/TWTooltip";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const AthleteSearchBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const getOptionLabel = (athlete: AthleteFragment) => `${athlete.lastName}, ${athlete.firstName}${athlete.isArchived ? " (Archived)" : ""}`;
  const getOptionSublabel = (athlete: AthleteFragment) => {
    const teams = athlete.teams.map(t => t.name).join(", ");
    return teams.length > 30 ? <TWTooltip title={getOptionLabel(athlete)} subcopy={teams}>
        <Typography sx={theme => ({ color: theme.palette.mediumEmphasisText })} variant="subtitle1">
          {teams.slice(0, 45) + "..."}
        </Typography>
      </TWTooltip> : teams;
  };
  const handleChange = (athlete: AthleteFragment | null) => {
    if (athlete && athlete.teams.length > 0) {
      navigate(getNavOrgAthleteWithTeam(athlete.id, athlete.teams[0].id));
    }
  };
  return (
    <AutocompleteQuerySearchBar<AthleteFragment, AthleteSearchQuery, AthleteSearchQueryVariables>
      query={AthleteSearchDocument}
      placeholder={t("athlete.searchBar.placeholder")}
      getOptionLabel={getOptionLabel}
      getOptionSublabel={getOptionSublabel}
      getOptionsFromQueryData={data => [...data.athleteSearch]}
      getQueryOptions={query => ({
        variables: { query, limit: 25 },
      })}
      onChange={handleChange}
      getUserFriendlyQueryErrorMessage={() => t("athlete.searchBar.error")}
      groupBy={{
        label: a => (a.isArchived ? "Archived" : ""),
        sort: (a, b) => (a.isArchived === b.isArchived ? 0 : a.isArchived ? 1 : -1),
      }}
      sx={{ minWidth: 320 }}
    />
  );
};
